import { z } from "zod";
import { createTRPCRouter, protectedProcedure } from "../trpc";
import { TRANSACTION_TYPE } from "@prisma/client";
import { sortByNepaliDate } from "../utils";

export const expenseRouter = createTRPCRouter({
    getExpenseTable: protectedProcedure
        .query(async ({ ctx }) => {
            const response = await ctx.prisma.transaction.findMany({
                where: {
                    type: TRANSACTION_TYPE.EXPENSE,
                    isActive: true
                },
                include: {
                    expense: {
                        select: { id: true }
                    }
                }
            });

            const sortedResponse = response.sort(sortByNepaliDate)
            const expenses = sortedResponse.map((txn) => ({
                id: txn.expense?.id,
                ...txn,
                income: undefined
            }));

            return expenses;
        }),

    // getExpenseById: publicProcedure
    //     .input(z.object({
    //         id: z.number()
    //     }))
    //     .query(async ({ ctx, input }) => {
    //         const expense = await ctx.prisma.transaction.findUnique({
    //             where: {
    //                 id: input.id,
    //                 type: TRANSACTION_TYPE.EXPENSE
    //             }
    //         });
    //
    //         return expense;
    //     }),

    createExpense: protectedProcedure
        .input(
            z.object({
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(1, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const newExpense = await ctx.prisma.transaction.create({
                data: {
                    ...input,
                    type: TRANSACTION_TYPE.EXPENSE,
                    isActive: true,
                    expense: {
                        create: {}
                    }
                }
            });

            return newExpense;
        }),

    updateExpenseTable: protectedProcedure
        .input(
            z.object({
                transactionId: z.number(),
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(1, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const { transactionId, ...data } = input;

            const updatedExpense = await ctx.prisma.transaction.update({
                where: {
                    transactionId,
                    type: TRANSACTION_TYPE.EXPENSE
                },
                data
            });

            return updatedExpense;
        }),

    // IF THERE WILL BE NEED FOR THE DELETION
    // WE WILL BE WORKING WITH SOFT DELETE

    // deactivateExpense: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({ ctx, input }) => {
    //     const deactivatedExpense = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.EXPENSE
    //       },
    //       data: {
    //         isActive: false
    //       }
    //     });
    //     
    //     return deactivatedExpense;
    //   }),

    // reactivateExpense: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({ input }) => {
    //     const reactivatedExpense = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.EXPENSE
    //       },
    //       data: {
    //         isActive: true
    //       }
    //     });
    //     
    //     return reactivatedExpense;
    //   }),
});
